
import React, { useState, useEffect, useContext, useMemo } from "react";

import { useNavigate, Link, useLocation, useParams } from "react-router-dom";
import moment from "moment";
import { contentContext } from "../../context/contentContext";
import { visibleMenus } from "../../utils/adminRoles";
import "./sidebar.css";

let { appname } = window.app;

// Sidebar sections, keyed by the menu name with spaces removed and lowercased (the same
// key handleMenu turns into a route). Order within a section follows this list.
const MENU_SECTIONS = [
    { title: "Overview", menus: ["dashboard", "revenue", "payouts", "transactions", "subscriptions"] },
    { title: "Manage", menus: ["clients", "users", "categories", "notifications"] },
    { title: "Configure", menus: ["visitorappsettings", "settings", "appconfig", "servicesconfig"] },
];

// Line icons for the known menus; anything else uses the icon saved on its permission.
const MENU_ICONS = {
    dashboard: "grid_view",
    revenue: "monitoring",
    payouts: "payments",
    transactions: "receipt_long",
    subscriptions: "subscriptions",
    clients: "group",
    users: "person",
    categories: "category",
    notifications: "notifications",
    visitorappsettings: "smartphone",
    settings: "settings",
};

const cloudfrontBase = () => window.site?.common?.imageCloudfront || process.env.REACT_APP_IMAGE_CLOUD_FRONT;


const Sidebar = () => {
    let { id } = useParams();
    const location = useLocation();

    const [manage, setManage] = useState(false);
    const [report, setReport] = useState(false);
    const [settings, setSettings] = useState(false);
    const [auction, setAuction] = useState(false);
    const isActive = (path) => location.pathname === path ? 'active' : '';
    // const [activeMenuObj, setActiveMenuObj] = useState({});
    const navigate = useNavigate();
    const [imageCloudfront, setImageCloudfront] = useState(cloudfrontBase());

    // window.site can arrive after the first render (the header waits for it the same way).
    useEffect(() => {
        if (window.site?.common?.imageCloudfront) return;
        const timer = setTimeout(() => setImageCloudfront(cloudfrontBase()), 1000);
        return () => clearTimeout(timer);
    }, []);


    const { isLoading, setIsLoading, setActiveTab, flagg, setData, setBidsAdvSearch, setSaveLeadId, setlookUpType, setBidsSearch, setLookupSearch, setClientNameSearch, setFlagg, setActivePageName, setUserSearch, setCompanyAdvSearch, setCompanySearch, setClientMangeSearch, setDealSearch, setClientAdvSearch, setDealsAdvSearch, userData, setContent, setSearchPayload, setCategorySearch, setContentSearch, leadSearch, setFilterLeads, setLeadSearch, setActiveSearch, setUserData, activeMenuObj, setActiveMenuObj, activeMenuId, GetTimeActivity, toggleMenu, setToggleMenu, setActiveMenuId, setSortingPayload, setItemSearch, guardedNavigate } = useContext(contentContext)



    //     const handleMenu = (e, item) => {
    //         if (!isLoading && activeMenuId !== item.menuid) {
    //             setActiveTab("details")
    //             // console.log('handleMenu-------------->',item.menuid)

    //             setActiveMenuId(item.menuid)
    //             let id = item.menu.split(" ").join("").toLowerCase()
    //             GetTimeActivity()
    //             setFlagg("")
    //             setLeadSearch("")
    //             setActiveSearch("")
    //             setFilterLeads("")
    //             setContentSearch("")
    //             setCategorySearch("")
    //             setSearchPayload({})
    //             setClientAdvSearch({})
    //             setBidsSearch("")
    //             setItemSearch("");
    //             setDealSearch("")
    //             setSortingPayload("")
    //             setlookUpType("")
    //             setClientNameSearch("")
    //             setSaveLeadId("")
    //             setDealsAdvSearch({})
    //             setData([])
    //             setLookupSearch("")
    //             setClientMangeSearch("")
    //             setBidsAdvSearch({})
    //             setCompanyAdvSearch({})
    //             setCompanySearch("")
    //             setUserSearch("")
    //             setActivePageName("")
    //             setContent([])
    //             if (id === "servicesconfig") {
    //                 navigate("/settings/serviceconfig");
    //             } else if (id === "appconfig") {
    //                 navigate("/settings/" + id);
    //             }
    //             else {

    //                 guardedNavigate(() => {
    //     navigate("/clients");
    // });
    //                 // navigate("/" + id);
    //             }

    //         }
    //     }

    const handleMenu = (e, item) => {
        if (isLoading || activeMenuId === item.menuid) return;

        const id = item.menu.split(" ").join("").toLowerCase();

        guardedNavigate(() => {
            // ✅ move ALL navigation-related state here
            setActiveTab("details");
            setActiveMenuId(item.menuid);
            GetTimeActivity()
            setFlagg("")
            setLeadSearch("")
            setActiveSearch("")
            setFilterLeads("")
            setContentSearch("")
            setCategorySearch("")
            setSearchPayload({})
            setClientAdvSearch({})
            setBidsSearch("")
            setItemSearch("");
            setDealSearch("")
            setSortingPayload("")
            setlookUpType("")
            setClientNameSearch("")
            setSaveLeadId("")
            setDealsAdvSearch({})
            setData([])
            setLookupSearch("")
            setClientMangeSearch("")
            setBidsAdvSearch({})
            setCompanyAdvSearch({})
            setCompanySearch("")
            setUserSearch("")
            setActivePageName("")
            setContent([])
            if (id === "servicesconfig") {
                navigate("/settings/serviceconfig");
            } else if (id === "appconfig") {
                navigate("/settings/" + id);
            } else if (id === "settings") {
                navigate("/settings/appconfig");
            } else {
                navigate("/" + id);
            }
        });
    };

    function sortPermissions(permissions) {
        // `sortOrder` lets a menu added later slot between existing ids (Revenue sits
        // right after Transactions) without renumbering anyone's saved permissions.
        const position = (p) => (p?.sortOrder != null ? p.sortOrder : p.menuid);
        return permissions.sort((a, b) => position(a) - position(b));
    }


    const handleActiveMenuObj = (e, name) => {
        GetTimeActivity()
        setActiveTab("details")
        setFlagg("")
        setLeadSearch("")
        setActiveSearch("")
        setFilterLeads("")
        setCategorySearch("")
        setDealsAdvSearch({})
        setContent([])
        setDealSearch("")
        setClientMangeSearch("")

        setBidsAdvSearch({})
        setClientNameSearch("")
        setLookupSearch("")
        setClientAdvSearch({})
        setCompanySearch("")
        setSearchPayload({})
        setlookUpType("")
        setCompanyAdvSearch({})
        setActivePageName("")
        setUserSearch("")
        // console.log('handleActiveMenuObj------------>',name)
        setActiveMenuObj({ ...activeMenuObj, [name]: !activeMenuObj[name] })

    }
    const handleMenuClick = (path) => {
        navigate(path);

    };
    const menuKey = (item) => String(item?.menu || "").split(" ").join("").toLowerCase();

    // Split the visible menus into the sidebar's sections. A menu that no section names
    // (a new one added to permissions) is listed at the end of "Manage".
    const sections = useMemo(() => {
        const visible = userData?.permissions?.length > 0 ? sortPermissions(visibleMenus(userData)) : [];
        const grouped = MENU_SECTIONS.map((section) => ({ ...section, items: [] }));
        const fallback = grouped.find((section) => section.title === "Manage");
        visible.forEach((item) => {
            const section = grouped.find((s) => s.menus.includes(menuKey(item))) || fallback;
            section.items.push(item);
        });
        grouped.forEach((section) => {
            const rank = (item) => {
                const index = section.menus.indexOf(menuKey(item));
                return index === -1 ? section.menus.length : index;
            };
            section.items.sort((a, b) => rank(a) - rank(b));
        });
        return grouped.filter((section) => section.items.length > 0);
    }, [userData]); // eslint-disable-line react-hooks/exhaustive-deps

    const renderIcon = (item) => (
        <i className="material-symbols-outlined" id={`sidemenu-${item.menuid}-icon`}>
            {MENU_ICONS[menuKey(item)] || item.icon}
        </i>
    );

    return (
        <>

            <div className={`vertical-menu admin-sidebar ${toggleMenu ? 'menu-show' : 'menu-hide'}`}>

                <div className="admin-sidebar-brand">
                    <img src={`${imageCloudfront}${appname}/images/web/logo-white.svg`} alt="SpotSaver" />
                    <span className="admin-sidebar-badge">Admin</span>
                </div>

                <div className="admin-sidebar-scroll">

                    <nav id="sidebar-menu">
                        {sections.map((section) => (
                            <div className="admin-sidebar-section" key={section.title}>
                                <p className="admin-sidebar-heading">{section.title}</p>
                                <ul className="metismenu list-unstyled" id={`side-menu-${section.title.toLowerCase()}`}>
                                    {section.items.map((eachItem) => (
                                        <li
                                            id={`sidemenu-${eachItem.menuid}`}
                                            key={eachItem.menuid}
                                            className={`${eachItem.menuid === activeMenuId ? 'active' : ''} ${isLoading ? 'pe-none' : ''}`}
                                            onClick={(e) =>
                                                eachItem.submenus === undefined
                                                    ? handleMenu(e, eachItem)
                                                    : handleActiveMenuObj(e, eachItem.menu)
                                            }
                                        >
                                            <a
                                                className={`${eachItem.submenus ? 'has-arrow' : ''}`}
                                                id={`sidemenu-${eachItem.menuid}-link`}
                                                aria-current={eachItem.menuid === activeMenuId ? "page" : undefined}
                                            >
                                                {renderIcon(eachItem)}
                                                <span id={`sidemenu-${eachItem.menuid}-text`}>
                                                    {eachItem.menu}
                                                </span>
                                            </a>
                                            {eachItem.submenus && eachItem.submenus.length > 0 && (
                                                <ul
                                                    className={
                                                        activeMenuObj[eachItem.menu]
                                                            ? 'sub-menu mm-show active'
                                                            : 'sub-menu mm-collapse'
                                                    }
                                                    aria-expanded={!!activeMenuObj[eachItem.menu]}
                                                    id={`sidemenu-${eachItem.menuid}-submenus`}
                                                >
                                                    {eachItem.submenus.map((eachSubmenu) => (
                                                        <li
                                                            id={`sidemenu-${eachSubmenu.menuid}`}
                                                            key={eachSubmenu.menuid}
                                                            className={`${eachSubmenu.menuid === activeMenuId ? 'active' : ''} ${isLoading ? 'pe-none' : ''}`}
                                                            onClick={(e) => { e.stopPropagation(); handleMenu(e, eachSubmenu); }}
                                                        >
                                                            <a id={`sidemenu-${eachSubmenu.menuid}-link`}>{eachSubmenu.menu}</a>
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </nav>


                    <p className="activity_time">Action: {localStorage.getItem("timeActivity")}</p>

                </div>
            </div>

        </>
    );
};

export default Sidebar;
